/**
 * CONSTANT: Disclaimers
 * @type {Object}
 *
 * This constant contains all of the disclaimer data for display within the application.
 * It's constructed as a JSON object, which can be used by both Vue and PDFMake.js
 */

const disclaimers = [

	{ 
		title: "disclaimers.generalTitle",
		list: [

				{
					term: "disclaimers.liraLifTitle",
				  def: "disclaimers.liraLif",
				 },

				{
					term: "disclaimers.inflationLifTitle",
				  def: "disclaimers.inflationLif",
				 },

				{
					term: "disclaimers.clawbackTitle",
				  def: "disclaimers.clawback",
				 },

		]

	},{

		title: "disclaimers.strategyTitle",
		list: [

				{
					term: "disclaimers.registeredFundsTitle",
				  def: "disclaimers.registeredFunds",
				 },

		]	

	}

]

export default {
  disclaimers,
}


// WEBPACK FOOTER //
// ./src/vuex/disclaimers.js